import { NotifyHelper } from "../../../helpers/toast";
import { eDotThiActionsObj } from "../../action-types/tct/IDotThiActions";
import { generateActionForKey, generateActions } from "../generateActions";

export const dotThiActions = {
    ...generateActions(eDotThiActionsObj, "DOT_THI"),
    ...generateActionForKey(eDotThiActionsObj, "DOT_THI", "SAVE_SUCCESS", () => NotifyHelper.Success("Thành công")),
    ...generateActionForKey(eDotThiActionsObj, "DOT_THI", "DELETE_SUCCESS", () => NotifyHelper.Success("Thành công")),
    ...generateActionForKey(eDotThiActionsObj, "DOT_THI", "SAVE_ERROR", (m) => NotifyHelper.Error(m)),
    ...generateActionForKey(eDotThiActionsObj, "DOT_THI", "DELETE_ERROR", (m) => NotifyHelper.Error(m)),
};
